var React = require('react');

function Magma (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M15.056 13.998l.463.908H8.481l.463-.909 3.05-6.001.006.01.006-.01 3.05 6.002zm-3.784-7.445l-3.958 7.76a1.3 1.3 0 00-.144.593H.844L8.18.47l3.091 6.084zm1.456 0L15.819.469l7.337 14.437H16.83a1.3 1.3 0 00-.144-.593l-3.958-7.76z","fill":"#fff"}));
}

Magma.defaultProps = {"fill":"none","viewBox":"0 0 24 15"};

module.exports = Magma;

Magma.default = Magma;
